if (!customElements.get('dynamic-dates')) {
  customElements.define(
    'dynamic-dates',
    class DynamicDates extends HTMLElement {
      connectedCallback() {
        const textEl = this.querySelector('[data-dynamic-date="true"]');
        if (!textEl) return;

        const template = textEl.dataset.text || '';
        const minDays = parseInt(textEl.dataset.minDays, 10) || 0;
        const maxDays = parseInt(textEl.dataset.maxDays, 10) || 0;

        const dayLabels = this.splitLabels(this.dataset.dayLabels);
        const monthLabels = this.splitLabels(this.dataset.monthLabels);
        const skipDays = this.splitLabels(this.dataset.daysToSkip, true);
        const skipDates = this.splitLabels(this.dataset.datesToSkip, true);

        const startDate = this.addShippingDays(minDays, skipDays, skipDates);
        const endDate = this.addShippingDays(maxDays, skipDays, skipDates);

        const format = this.dataset.dateFormat || 'mm_dd';
        const startText = this.formatDate(startDate, format, dayLabels, monthLabels);
        const endText = this.formatDate(endDate, format, dayLabels, monthLabels);

        textEl.innerHTML = template.replace('[start_date]', startText).replace('[end_date]', endText);
      }

      splitLabels(value, lowercase) {
        if (!value) return [];
        return value
          .split(',')
          .map((item) => item.trim())
          .filter((item) => item.length > 0)
          .map((item) => (lowercase ? item.toLowerCase() : item));
      }

      isSkipped(date, skipDays, skipDates) {
        const englishWeekdays = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
        const weekday = englishWeekdays[date.getDay()];
        if (skipDays.indexOf(weekday) !== -1) return true;

        const mm = String(date.getMonth() + 1).padStart(2, '0');
        const dd = String(date.getDate()).padStart(2, '0');
        if (skipDates.indexOf(`${mm}-${dd}`) !== -1) return true;

        return false;
      }

      addShippingDays(numDays, skipDays, skipDates) {
        const date = new Date();
        let remaining = numDays;
        while (remaining > 0) {
          date.setDate(date.getDate() + 1);
          if (!this.isSkipped(date, skipDays, skipDates)) remaining--;
        }
        return date;
      }

      ordinal(day) {
        if (day % 10 === 1 && day !== 11) return `${day}st`;
        if (day % 10 === 2 && day !== 12) return `${day}nd`;
        if (day % 10 === 3 && day !== 13) return `${day}rd`;
        return `${day}th`;
      }

      formatDate(date, format, dayLabels, monthLabels) {
        const dayName = dayLabels[(date.getDay() + 6) % 7] || '';
        const monthName = monthLabels[date.getMonth()] || '';
        const dayNum = date.getDate();
        const dayNumPadded = String(dayNum).padStart(2, '0');
        const monthNumPadded = String(date.getMonth() + 1).padStart(2, '0');

        switch (format) {
          case 'day_mm_dd':
            return `${dayName}, ${monthName} ${this.ordinal(dayNum)}`;
          case 'day_dd_mm':
            return `${dayName}, ${dayNum}. ${monthName}`;
          case 'dd_mm':
            return `${dayNum}. ${monthName}`;
          case 'dd_mm_no_dot':
            return `${dayNum} ${monthName}`;
          case 'day_dd_mm_numeric':
            return `${dayName}, ${dayNumPadded}. ${monthNumPadded}.`;
          case 'dd_mm_numeric':
            return `${dayNumPadded}. ${monthNumPadded}.`;
          case 'mm_dd':
          default:
            return `${monthName} ${this.ordinal(dayNum)}`;
        }
      }
    }
  );
}
